export const tableHeadingStyle = {
  background: "rgba(255, 255, 255, 0.07)",
  borderRadius: "160px",
  color: "white",
  borderBottom: "none",
};

export const columnStyle = {
  color: "white",
  fontWeight: "700",
  fontSize: "11px",
  padding: "8px",
  borderBottom: "none",
  lineHeight: "16px",
};

export const rowCellStyle = {
  color: "#B6B9BE",
  opacity: "0.7",
  fontSize: "0.8em",
  lineHeight: "15px",
  padding: "14px",
  borderBottom: "1px solid rgba(255, 255, 255,0.05)",
};

export const clubRowCell = {
  ...rowCellStyle,
  color: "white",
  borderBottom: "1px solid rgba(255, 255, 255,0.025)",
};

export const tableRow = {
  borderBottom: "none",
  background: "rgba(255, 255, 255, 0.03)",
  cursor: "pointer",
  "&:hover": {
    background: "red !important",
  },
};

export const tableRowHover = {
  ...tableRow,
  background: "rgba(255, 255, 255, 0.05)",
};

export const tableWrapper = {
  borderRadius: "8px",
};

export const emptyTable = {
  display: "flex",
  width: "100%",
  height: "76px",
  color: "rgba(255, 255, 255, 0.7)",
  fontWeight: 500,
  fontSize: "12px",
  lineHeight: "16px",
  borderBottom: "none",
};
